import { mapGetters } from 'vuex'

const index = () => import('./the-admin')
const dashboard = () => import('@app/admin')
const vp = () => import('@app/vp')
const modulos = () => import('@app/admin/modulos')
const modulosForm = () => import('@app/admin/modulos/form')
const funcionalidades = () => import('@app/admin/funcionalidades')
const funcionalidadesForm = () => import('@app/admin/funcionalidades/form')
const perfis = () => import('@app/admin/perfis')
const perfisForm = () => import('@app/admin/perfis/form')
const usuarios = () => import('@app/admin/usuarios')
const usuariosForm = () => import('@app/admin/usuarios/form')
const contasBancarias = () => import('@app/admin/contasBancarias')
const contasBancariasForm = () => import('@app/admin/contasBancarias/form')
const servicos = () => import('@app/admin/servicos')
const servicosForm = () => import('@app/admin/servicos/form')
const contas = () => import('@app/admin/contas')
const contasForm = () => import('@app/admin/contas/form')
const comprarFichas = () => import('@app/admin/comprarFichas')
const comprarFichasForm = () => import('@app/admin/comprarFichas/form')
const venderFichas = () => import('@app/admin/venderFichas')
const indicacoes = () => import('@app/admin/indicacoes')
const venderFichasForm = () => import('@app/admin/venderFichas/form')
const transacoesCompraVenda = () => import('@app/admin/transacoesCompraVenda')
const transacoesCompraVendaForm = () => import('@app/admin/transacoesCompraVenda/form')
const historicosTransacoesCompraVenda = () => import('@app/admin/transacoesCompraVenda')
const transacoesIntegradas = () => import("@app/admin/transacoesIntegradas");
const transacoesIntegradasForm = () => import("@app/admin/transacoesIntegradas/form");
const historicosTransacoesIntegradas = () => import("@app/admin/transacoesIntegradas");
const transacao = () => import('@app/admin/transacoes/form')
const astroPay = () => import('@app/admin/astroPay')
const contasBancariasUsuario = () => import('@app/admin/contasBancariasUsuarios')
const notaFiscal = () => import('@app/admin/notaFiscal')
const comprarCursos = () => import('@app/admin/comprarCursos')

export default [
  {
    computed: {
      ...mapGetters('auth', ['getUsuario'])
    },
    path: '/dashboard',
    name: 'admin.index',
    meta: {
      breadcrumb: [{
        text: 'Home',
        href: '/dashboard',
        route: 'admin.dashboard'
      }, {
        text: 'Dashboard',
        active: true
      }]
    },
    component: index,
    children: [
      {
        path: '/dashboard',
        name: 'admin.dashboard',
        component: dashboard,
        beforeEnter: (to, from, next) => {
          if (from.name !== 'register.index' || from.name !== 'forgotpassword.index' || from.name !== 'auth.index') {
            next(true)
          }
        },
        meta: {
          breadcrumb: [{
            text: 'Home',
            href: '/dashboard',
            route: 'admin.dashboard'
          }, {
            text: 'Dashboard',
            active: true
          }]
        }
      },
      {
        path: '/dashboard',
        name: 'vp.dashboard',
        component: vp,
        redirect: '/dashboard',
        beforeEnter: (to, from, next) => {
          if (from.name !== 'register.index' || from.name !== 'forgotpassword.index' || from.name !== 'auth.index') {
            next({ name: from.name.toString() })
            // next(true)
          }
        },
        meta: {
          breadcrumb: [{
            text: 'Royalpag',
            href: '/dashboard',
            route: 'vp.dashboard'
          }, {
            text: 'Dashboard',
            active: true
          }]
        }
      },
      {
        path: '/modulos',
        name: 'modulos.index',
        component: modulos,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Módulos',
            href: '/modulos',
            active: true
          }]
        }
      },
      {
        path: '/notaFiscal',
        name: 'notaFiscal.index',
        component: notaFiscal,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Nota Fiscal',
            href: '/notaFiscal',
            active: true
          }]
        }
      },
      {
        path: '/contasBancarias',
        name: 'contasBancarias.index',
        component: contasBancarias,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Contas Bancárias',
            href: '/contasBancarias',
            active: true
          }]
        }
      },
      {
        path: 'contasBancariasForm/:id?',
        name: 'contasBancarias.form',
        component: contasBancariasForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'admin.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Contas Bancárias',
              href: '/contasBancarias',
              route: 'contasBancarias.index'
            },
            {
              text: 'Dados da conta bancária',
              href: '/contasBancariasForm',
              active: true
            }
          ]
        }
      },
      {
        path: '/contasBancariasUsuario',
        name: 'contasBancariasUsuarios.index',
        component: contasBancariasUsuario,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Contas Bancárias Usuário',
            href: '/contasBancariasUsuario',
            active: true
          }]
        }
      },
      {
        path: '/servicos',
        name: 'servicos.index',
        component: servicos,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Serviços',
            href: '/servicos',
            active: true
          }]
        }
      },
      {
        path: '/astroPay',
        name: 'astroPay.index',
        component: astroPay,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-credit-card'
          }, {
            text: 'AstroPay',
            href: '/astroPay',
            active: true
          }]
        }
      },
      {
        path: 'servicosForm/:id?',
        name: 'servicos.form',
        component: servicosForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'admin.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Serviços',
              href: '/servicos',
              route: 'servicos.index'
            },
            {
              text: 'Dados do serviço',
              href: '/servicosForm',
              active: true
            }
          ]
        }
      },
      {
        path: '/contas',
        name: 'contas.index',
        component: contas,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Contas',
            href: '/contas',
            active: true
          }]
        }
      },
      {
        path: 'contasForm/:id?',
        name: 'contas.form',
        component: contasForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'vp.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Contas',
              href: '/contas',
              route: 'contas.index'
            },
            {
              text: 'Dados das contas',
              href: '/contasForm',
              active: true
            }
          ]
        }
      },
      {
        path: '/comprarFichas',
        name: 'comprarFichas.index',
        component: comprarFichas,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Compra Fichas',
            href: '/comprarFichas',
            active: true
          }]
        }
      },
      {
        path: 'comprarFichasForm/:id?',
        name: 'comprarFichas.form',
        component: comprarFichasForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'admin.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Compra',
              href: '/comprarFichas',
              route: 'comprarFichas.index'
            },
            {
              text: 'Compra de Fichas',
              href: '/comprarFichasForm',
              active: true
            }
          ]
        }
      },
      {
        path: '/venderFichas',
        name: 'venderFichas.index',
        component: venderFichas,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Vender Fichas',
            href: '/venderFichas',
            active: true
          }]
        }
      },
      {
        path: 'venderFichasForm/:id?',
        name: 'venderFichas.form',
        component: venderFichasForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'admin.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Vender',
              href: '/venderFichas',
              route: 'venderFichas.index'
            },
            {
              text: 'Venda de Fichas',
              href: '/venderFichasForm',
              active: true
            }
          ]
        }
      },
      {
        path: 'modulosForm/:id?',
        name: 'modulos.form',
        component: modulosForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'admin.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Módulos',
              href: '/modulos',
              route: 'modulos.index'
            },
            {
              text: 'Dados do Módulo',
              href: '/modulosForm',
              active: true
            }
          ]
        }
      },
      {
        path: '/funcionalidades',
        name: 'funcionalidades.index',
        component: funcionalidades,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Funcionalidades',
            href: '/funcionalidades',
            active: true
          }]
        }
      },
      {
        path: 'funcionalidadesForm/:id?',
        name: 'funcionalidades.form',
        component: funcionalidadesForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'admin.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Funcionalidades',
              href: '/funcionalidades',
              route: 'funcionalidades.index'
            },
            {
              text: 'Dados da Funcionalidade',
              href: '/funcionalidadesForm',
              active: true
            }
          ]
        }
      },
      {
        path: '/perfis',
        name: 'perfis.index',
        component: perfis,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Perfis',
            href: '/perfis',
            active: true
          }]
        }
      },
      {
        path: 'perfisForm/:id?',
        name: 'perfis.form',
        component: perfisForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'admin.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Perfis',
              href: '/perfis',
              route: 'perfis.index'
            },
            {
              text: 'Dados do Perfil',
              href: '/perfisForm',
              active: true
            }
          ]
        }
      },
      {
        path: '/transacao/:id',
        name: 'transacao.index',
        component: transacao,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Transação',
            href: '/transacaoForm',
            active: true
          }]
        }
      },
      {
        path: '/transacoesCompraVenda',
        name: 'transacoesCompraVenda.index',
        component: transacoesCompraVenda,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Transações de Compra e Venda',
            href: '/transacoesCompraVenda',
            active: true
          }]
        }
      },
      {
        path: '/transacoesCompraVendaArquivadas',
        name: 'transacoesCompraVendaArquivadas.index',
        component: transacoesCompraVenda,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Transações de Compra e Venda Arquivadas',
            href: '/transacoesCompraVendaArquivadas',
            active: true
          }]
        }
      },
      {
        path: '/historico',
        name: 'historico.index',
        component: historicosTransacoesCompraVenda,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Histórico de Compra e Venda',
            href: '/historico',
            active: true
          }]
        }
      },
      {
        path: 'transacoesCompraVendaForm/:id?',
        name: 'transacoesCompraVenda.form',
        component: transacoesCompraVendaForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'admin.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Transações de Compra e Venda',
              href: '/transacoesCompraVenda',
              route: 'transacoesCompraVenda.index'
            },
            {
              text: 'Histórico Transações de Compra e Venda',
              href: '/transacoesCompraVendaForm',
              active: true
            }
          ]
        }
      },
      {
        path: '/usuarios',
        name: 'usuarios.index',
        component: usuarios,
        meta: {
          breadcrumb: [{
            text: 'Dashboard',
            href: '/dashboard',
            route: 'admin.dashboard',
            useIcon: true,
            icon: 'ti-home'
          }, {
            text: 'Usuários',
            href: '/usuarios',
            active: true
          }]
        }
      },
      {
        path: 'usuariosForm/:id?',
        name: 'usuarios.form',
        component: usuariosForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'admin.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Usuários',
              href: '/usuarios',
              route: 'usuarios.index'
            },
            {
              text: 'Dados do Usuário',
              href: '/usuariosForm',
              active: true
            }
          ]
        }
      },
      {
        path: 'profile',
        name: 'user.profile/:id?',
        component: usuariosForm,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'vp.dashboard',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Dados pessoais',
              href: '/profile',
              active: true
            }
          ]
        }
      },
      {
        path: 'indicacoes',
        name: 'indicacoes.index',
        component: indicacoes,
        meta: {
          breadcrumb: [
            {
              text: 'Dashboard',
              href: '/dashboard',
              route: 'admin.indicacoes',
              useIcon: true,
              icon: 'ti-home'
            },
            {
              text: 'Indicações',
              href: '/indicacoes',
              active: true
            }
          ]
        }
      },
      {
        path: "/transacoesIntegradas",
        name: "transacoesIntegradas.index",
        component: transacoesIntegradas,
        meta: {
          breadcrumb: [
            {
              text: "Dashboard",
              href: "/dashboard",
              route: "admin.dashboard",
              useIcon: true,
              icon: "ti-home"
            },
            {
              text: "Transações Integradas de Compra e Venda",
              href: "/transacoesIntegradas",
              active: true
            }
          ]
        }
      },
      {
        path: "/historico",
        name: "historico.index",
        component: historicosTransacoesIntegradas,
        meta: {
          breadcrumb: [
            {
              text: "Dashboard",
              href: "/dashboard",
              route: "admin.dashboard",
              useIcon: true,
              icon: "ti-home"
            },
            {
              text: "Histórico de Transações Integradas de Compra e Venda",
              href: "/historico",
              active: true
            }
          ]
        }
      },
      {
        path: "transacoesIntegradasForm/:id?",
        name: "transacoesIntegradas.form",
        component: transacoesIntegradasForm,
        meta: {
          breadcrumb: [
            {
              text: "Dashboard",
              href: "/dashboard",
              route: "admin.dashboard",
              useIcon: true,
              icon: "ti-home"
            },
            {
              text: "Transações Integradas de Compra e Venda",
              href: "/transacoesIntegradas",
              route: "transacoesIntegradas.index"
            },
            {
              text: "Histórico Transações Integradas de Compra e Venda",
              href: "/transacoesIntegradasForm",
              active: true
            }
          ]
        }
      },
      {
        path: '/comprarCursos',
        name: 'comprarCursos',
        component: comprarCursos,
        meta: {
          breadcrumb: [{
            text: "Home",
            href: "/",
            route: "#",
            useIcon: true,
            icon: "ti-home"
          }, {
            text: 'Comprar Produtos',
            href: '/comprarCursos',
            active: true
          }]
        }
      },

    ]

  }
]



// WEBPACK FOOTER //
// ./src/components/admin/routes.js